import { render, staticRenderFns } from "./editPicture.vue?vue&type=template&id=4e097962"
import script from "./editPicture.vue?vue&type=script&lang=js"
export * from "./editPicture.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports